<template>
  <v-app>
    <v-navigation-drawer
      v-if="$route.name !== 'Login'"
      class="nav-drawer"
      dark
      app
      permanent
      :mini-variant.sync="mini"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            OCM
          </v-list-item-title>
          <v-list-item-subtitle>
            Gestionale
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon>fa fa-angle-double-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <template v-for="(items, label) in menuItemsForUser">
          <v-subheader :key="label">
            <span v-if="!mini">{{ label.toUpperCase() }}</span>
          </v-subheader>
          <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="item.to"
            link
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2 white--text text-center">
          <p v-if="!profile.is_staff">
            <select
              v-model="$language.current"
              name="language"
              class="white--text text-overline"
            >
              <option
                v-for="(language, key) in $language.available"
                :key="key"
                :value="key"
                class="white--text text-overline"
              >
                {{ language }}
              </option>
            </select>
          </p>
          <p v-if="get(profile, 'person__name')">
            {{ get(profile, "person__name") }}
          </p>
          <v-btn block @click="logout">Logout</v-btn>
          <v-divider class="my-3"></v-divider>
          <p class="text-caption" style="line-height: 1.2">
            Questo gestionale è stato realizzato nell'ambito di "Ode
            Virtuosity", finanziato dall'Unione europea – Next Generation EU -
            PNRR Transizione Ecologica Organismi Culturali e Creativi
          </p>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>fas fa-external-link-alt</v-icon>
      </v-btn>
    </v-app-bar> -->

    <v-content class="main">
      <keep-alive :include="['List']">
        <router-view />
      </keep-alive>
    </v-content>

    <cacher />
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data() {
    return {
      mini: false,
      menuItems: {
        Anagrafica: [
          {
            title: "Persone",
            icon: "fa-user fa-fw",
            to: { name: "People" },
          },
          {
            title: "Categorie",
            icon: "fa-user-tag fa-fw",
            to: { name: "PersonCategories" },
          },
          {
            title: "Ruoli",
            icon: "fa-user-shield fa-fw",
            to: { name: "PersonRoles" },
          },
          {
            title: "Gruppi",
            icon: "fa-users fa-fw",
            to: { name: "Bands" },
          },
          {
            title: "Compagnie di trasporto",
            icon: "fa-users fa-fw",
            to: { name: "TransportCompanies" },
          },
          {
            title: "Luoghi",
            icon: "fa-landmark fa-fw",
            to: { name: "Places" },
          },
          {
            title: "Strumenti",
            icon: "fa-drum fa-fw",
            to: { name: "Instruments" },
          },
          {
            title: "Hotels",
            icon: "fa-home fa-fw",
            to: { name: "Hotels" },
          },
          {
            title: "Stanze",
            icon: "fa-key fa-fw",
            to: { name: "Rooms" },
          },
        ],
        Edizioni: [
          {
            title: this.$gettext("Manifestazioni"),
            icon: "far fa-calendar fa-fw",
            to: { name: "Shows" },
          },
        ],
        Export: [
          {
            title: "Esporta eventi",
            icon: "fa-table fa-fw",
            to: { name: "ExportEvents" },
          },
        ],
      },
    }
  },

  computed: {
    menuItemsForUser() {
      const { Anagrafica, Edizioni, Export } = this.menuItems
      if (this.profile.is_staff) {
        return { Anagrafica, Edizioni, Export }
      } else {
        return {
          Profilo: [
            {
              title: this.$gettext("Il mio profilo"),
              icon: "fa-user fa-fw",
              to: {
                name: "EditPerson",
                params: { id: this.profile.person_id },
              },
            },
          ],
          Edizioni,
        }
      }
    },
  },

  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login")
      })
    },
  },
}
</script>

<style>
@media print {
  .nav-drawer {
    display: none !important;
    height: 0;
    width: 0;
  }

  .main {
    padding-left: 0 !important;
  }
}
</style>
